import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, UntypedFormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-change-size',
  templateUrl: './change-size.component.html',
  styleUrls: ['./change-size.component.scss']
})
export class ChangeSizeComponent implements OnInit {

  tree_type

  width: string;
  height: string;
  // types: string[] = ['A0', 'A1', 'A2', 'A3', 'A4', 'Custom'];
  types: string[] = ['A0', 'A1', 'A2'];
  selectedType: string;
  isDisabled = true;

  opacities = [
    { value: '0.1', label: '10%' },
    { value: '0.2', label: '20%' },
    { value: '0.3', label: '30%' },
    { value: '0.4', label: '40%' },
    { value: '0.5', label: '50%' },
    { value: '0.6', label: '60%' },
    { value: '0.7', label: '70%' },
    { value: '0.8', label: '80%' },
    { value: '0.9', label: '90%' },
    { value: '1', label: '100%' },
  ]

  selectedOpacity: string;
  selectedNodeOpacity: string;

  public color: ThemePalette = 'primary';
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ChangeSizeComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
  }

  paper = this.fb.group({
    paperType: '',
    maxGeneration: '',
    borderWidth: '',
    cornerRound: '',
    global_padding: '',
    empty_node_setting: '',
    text_align: '',
    name_text_align: '',
    partner_setting: '',
    children_setting: '',
    flag_setting: '',
    selectedOpacity: '',
    selectedNodeOpacity: '',
    profile_setting: '',
    warning_setting: '',
    birth_info_setting: '',
    marriage_info_setting: '',
    death_info_setting: '',
    borderColor: '',
    maleColor: '',
    femaleColor: '',
    maleNodeColor: '',
    femaleNodeColor: '',
  });
  ngOnInit() {

    this.tree_type = localStorage.getItem("type")
    this.paper.patchValue({
      paperType: localStorage.getItem('papertype'),
      maxGeneration: localStorage.getItem('maxGeneration'),
      borderWidth: localStorage.getItem('borderWidth'),
      cornerRound: localStorage.getItem('cornerRound'),
      global_padding: localStorage.getItem('global_padding'),
      empty_node_setting: localStorage.getItem('empty_node_setting'),
      text_align: localStorage.getItem('text_align'),
      name_text_align: localStorage.getItem('name_text_align'),
      partner_setting: localStorage.getItem('partner_setting'),
      children_setting: localStorage.getItem('children_setting'),
      flag_setting: localStorage.getItem('flag_setting'),
      selectedOpacity: localStorage.getItem('backOpacity'),
      selectedNodeOpacity: localStorage.getItem('nodeOpacity'),
      profile_setting: localStorage.getItem('profile_setting'),
      warning_setting: localStorage.getItem('warning_setting'),
      birth_info_setting: localStorage.getItem('birth_setting'),
      marriage_info_setting: localStorage.getItem('marriage_setting'),
      death_info_setting: localStorage.getItem('death_setting'),
      borderColor: localStorage.getItem('borderColor'),
      maleColor: localStorage.getItem('manColor'),
      femaleColor: localStorage.getItem('womanColor'),
      maleNodeColor: localStorage.getItem('maleNodeColor'),
      femaleNodeColor: localStorage.getItem('femaleNodeColor'),
    }) 
    this.width = localStorage.getItem('tree_width');
    this.height = localStorage.getItem('tree_height');
    this.onChanges();
  }

  onChanges(): void {
    // this.paper.valueChanges.subscribe( res => {
      // localStorage.setItem('papertype', this.paper.value.paperType);
      // localStorage.setItem('maxGeneration', this.paper.value.maxGeneration);
      // localStorage.setItem('borderWidth', this.paper.value.borderWidth);
      // localStorage.setItem('cornerRound', this.paper.value.cornerRound);
      // localStorage.setItem('global_padding', this.paper.value.global_padding);
      // localStorage.setItem('empty_node_setting', this.paper.value.empty_node_setting);
      // localStorage.setItem('text_align', this.paper.value.text_align);
      // localStorage.setItem('name_text_align', this.paper.value.name_text_align);
      // localStorage.setItem('partner_setting', this.paper.value.partner_setting);
      // localStorage.setItem('children_setting', this.paper.value.children_setting);
      // localStorage.setItem('flag_setting', this.paper.value.flag_setting);
      // localStorage.setItem('backOpacity', this.paper.value.selectedOpacity);
      // localStorage.setItem('nodeOpacity', this.paper.value.selectedNodeOpacity);
      // localStorage.setItem('profile_setting', this.paper.value.profile_setting);
      // localStorage.setItem('warning_setting', this.paper.value.warning_setting);
      // localStorage.setItem('borderColor', this.paper.value.borderColor);
      // localStorage.setItem('manColor', this.paper.value.maleColor);
      // localStorage.setItem('womanColor', this.paper.value.femaleColor);
      // localStorage.setItem('maleNodeColor', this.paper.value.maleNodeColor);
      // localStorage.setItem('femaleNodeColor', this.paper.value.femaleNodeColor);

      // this.width ? localStorage.setItem('tree_width', this.width) : ''
      // this.height ? localStorage.setItem('tree_height', this.height) : ''
  
      // if (this.paper.value.birth_info_setting === 'hide') {
      //   console.log('Hide empty');
      //   localStorage.setItem('birth_setting', this.paper.value.birth_info_setting);
      //   localStorage.setItem('birth_hide_empty', 'true')
      // } else {
      //   localStorage.setItem('birth_setting', this.paper.value.birth_info_setting);
      //   localStorage.setItem('birth_hide_empty', 'false')
      // }


      // if (this.paper.value.marriage_info_setting === 'hide') {
      //   localStorage.setItem('marriage_setting', this.paper.value.marriage_info_setting);
      //   localStorage.setItem('marriage_hide_empty', 'true')
      // } else {
      //   localStorage.setItem('marriage_setting', this.paper.value.marriage_info_setting);
      //   localStorage.setItem('marriage_hide_empty', 'false')
      // }

      // if (this.paper.value.death_info_setting === 'hide') {
      //   localStorage.setItem('death_hide_empty', 'true')
      //   localStorage.setItem('death_setting', this.paper.value.death_info_setting);
      // } else {
      //   localStorage.setItem('death_hide_empty', 'false')
      //   localStorage.setItem('death_setting', this.paper.value.death_info_setting);
      // }
    // })
  }

  setRecommendedSettings(){
    this.paper.patchValue({
      borderWidth: '2',
      cornerRound: '50',
      global_padding: '5',
      empty_node_setting: 'none',
      text_align: 'middle',
      name_text_align: 'middle',
      partner_setting: 'SHOW',
      children_setting: 'SHOW',
      flag_setting: 'HIDE',
      selectedOpacity: '1',
      selectedNodeOpacity: '1',
      profile_setting: 'SHOW',
      warning_setting: 'HIDE',
      birth_info_setting: 'block',
      marriage_info_setting: 'block',
      death_info_setting: 'block',
      borderColor: '#000000',
      maleColor: '#000000',
      femaleColor: '#000000',
      maleNodeColor: '#ffffff',
      femaleNodeColor: '#ffffff',
    }) 
    this.changePaper(localStorage.getItem('papertype'));
  }

  changePaper(value) {
    console.log(value)
    this.selectedType = value;
    switch (value) {
      case 'A0':
        this.width = '67408';
        this.height = '47679';
        this.isDisabled = true;
        this.paper.patchValue({
          maxGeneration: '10'
        })
        break;
      case 'A1':
        this.width = '47679';
        this.height = '33676';
        this.isDisabled = true;
        this.paper.patchValue({
          maxGeneration: '8'
        })
        break;
      case 'A2':
        this.width = '33676';
        this.height = '23811';
        this.isDisabled = true;
        this.paper.patchValue({
          maxGeneration: '7'
        })
        break;
      case 'A3':
        this.width = '23811';
        this.height = '16838';
        this.isDisabled = true;
        this.paper.patchValue({
          maxGeneration: '6'
        })
        break;
      case 'A4':
        this.width = '16838';
        this.height = '11906';
        this.isDisabled = true;
        this.paper.patchValue({
          maxGeneration: '5'
        })
        break;
      default:
        this.width = '';
        this.height = '';
        this.isDisabled = false;
    }
  }

  actionFunction() {
    localStorage.setItem('papertype', this.paper.value.paperType);
    localStorage.setItem('maxGeneration', this.paper.value.maxGeneration);
    localStorage.setItem('borderWidth', this.paper.value.borderWidth);
    localStorage.setItem('cornerRound', this.paper.value.cornerRound);
    localStorage.setItem('global_padding', this.paper.value.global_padding);
    localStorage.setItem('empty_node_setting', this.paper.value.empty_node_setting);
    localStorage.setItem('text_align', this.paper.value.text_align);
    localStorage.setItem('name_text_align', this.paper.value.name_text_align);
    localStorage.setItem('partner_setting', this.paper.value.partner_setting);
    localStorage.setItem('children_setting', this.paper.value.children_setting);
    localStorage.setItem('flag_setting', this.paper.value.flag_setting);
    localStorage.setItem('backOpacity', this.paper.value.selectedOpacity);
    localStorage.setItem('nodeOpacity', this.paper.value.selectedNodeOpacity);
    localStorage.setItem('profile_setting', this.paper.value.profile_setting);
    localStorage.setItem('warning_setting', this.paper.value.warning_setting);
    localStorage.setItem('borderColor', this.paper.value.borderColor);
    localStorage.setItem('manColor', this.paper.value.maleColor);
    localStorage.setItem('womanColor', this.paper.value.femaleColor);
    localStorage.setItem('maleNodeColor', this.paper.value.maleNodeColor);
    localStorage.setItem('femaleNodeColor', this.paper.value.femaleNodeColor);

    this.width ? localStorage.setItem('tree_width', this.width) : ''
    this.height ? localStorage.setItem('tree_height', this.height) : ''

    if (this.paper.value.birth_info_setting === 'hide') {
      console.log('Hide empty');
      localStorage.setItem('birth_setting', this.paper.value.birth_info_setting);
      localStorage.setItem('birth_hide_empty', 'true')
    } else {
      localStorage.setItem('birth_setting', this.paper.value.birth_info_setting);
      localStorage.setItem('birth_hide_empty', 'false')
    }


    if (this.paper.value.marriage_info_setting === 'hide') {
      localStorage.setItem('marriage_setting', this.paper.value.marriage_info_setting);
      localStorage.setItem('marriage_hide_empty', 'true')
    } else {
      localStorage.setItem('marriage_setting', this.paper.value.marriage_info_setting);
      localStorage.setItem('marriage_hide_empty', 'false')
    }

    if (this.paper.value.death_info_setting === 'hide') {
      localStorage.setItem('death_hide_empty', 'true')
      localStorage.setItem('death_setting', this.paper.value.death_info_setting);
    } else {
      localStorage.setItem('death_hide_empty', 'false')
      localStorage.setItem('death_setting', this.paper.value.death_info_setting);
    }
    this.dialogRef.close(true);
  }

  closeModal() {
    this.dialogRef.close();
  }

}
